import { PropType } from 'vue';
import { mapGetters } from 'vuex';
import debounce from 'lodash.debounce';
import plantsClient from '@/core/services/plants';
import { Vue, Options } from 'vue-class-component';
import {
  DeviceDTO,
  DeviceProximity,
  DeviceBrightness,
  DeviceLedModality,
  DeviceIconsVisibility,
  DeviceGlobalSettingsDTO,
  IDeviceGlobalSettingsDTO,
} from '@/../client-generator/generated-clients/plants';

@Options({
  name: 'PlantDevicesSettings',
  props: {
    device: {
      type: Object as PropType<DeviceDTO>,
      required: true,
    },
    desktopId: {
      type: Number,
      required: false,
    },
  },
  computed: {
    ...mapGetters('UI', ['plantDeviceSettingsEditEnabled']),
  },
})
export default class PlantDevicesSettings extends Vue {
  device!: DeviceDTO;
  desktopId!: number | null;

  DeviceProximity = DeviceProximity;
  DeviceBrightness = DeviceBrightness;
  DeviceLedModality = DeviceLedModality;
  DeviceIconsVisibility = DeviceIconsVisibility;

  created() {
    this.updateDeviceSettings = debounce(this.updateDeviceSettings, 1500);
  }

  async updateDeviceSettings() {
    if (!this.desktopId || !this.device) return;

    try {
      const request: IDeviceGlobalSettingsDTO = {
        deviceProximity: this.device.deviceProximity,
        deviceBrightness: this.device.deviceBrightness,
        showLedsInStandby: this.device.showLedsInStandby,
        isProximityEnabled: this.device.isProximityEnabled,
        deviceIconsVisibility: this.device.deviceIconsVisibility,
        ledIntensity:
          this.device.ledIntensity! > 10
            ? this.device.ledIntensity! / 10
            : this.device.ledIntensity,
        ledModality: this.device.ledModality,
        hasRefresherFeedback: this.device.hasRefresherFeedback,
      };

      await plantsClient.updateDeviceSettings(
        this.desktopId,
        this.device.uid!,
        new DeviceGlobalSettingsDTO(request)
      );
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
    }
  }

  unmounted() {
    this.updateDeviceSettings;
  }
}
